import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  href = '#comprar',
  className = '',
  onClick,
  fullWidth = false
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 bg-amber-400 hover:bg-amber-300 text-blue-950 font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 text-lg md:text-xl uppercase tracking-wide';
  const widthStyles = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) onClick();
  };
  return <a href={href} onClick={handleClick} className={`${baseStyles} ${widthStyles} ${className}`} data-id="element-347">
      {children}
      <ArrowRight className="w-6 h-6" data-id="element-348" />
    </a>;
}